import z from 'zod';

export const EmrIntegrationSchema = z.object({
  isIntegrated: z.boolean(),
  createdAt: z.string().nullable(),
  lastSyncedAt: z.string().nullable(),
});

export const LoginEmrFormSchema = z.object({
  username: z.string().min(1, 'Username is required'),
  password: z.string().min(1, 'Password is required'),
});
